import { Component } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-echo-graphs',
  templateUrl: './echo-graphs.component.html',
  styleUrls: ['./echo-graphs.component.css']
})
export class EchoGraphsComponent {
  roxData: any;
  options: any;
  loading: boolean = true;

  constructor(private dataService: DataService){}

  ngOnInit() {
    this.dataService.getEchoGraphs().then(data => {
      this.roxData = data[0];
      this.loading = false;
    });

    this.options = {
        maintainAspectRatio: false,
        aspectRatio: .4,
        showLine: false
    };
  }

}
